export const EPerformaceReferenceDuration = {
  //in ms
  DEFAULT: 1 * 1000,

  //in ms
  SERVER_START: 2000,

  //in ms
  AUTH_DATA_SENT: 2 * 1000,

  //in ms
  RESPONSE_FROM_SERVER: 1 * 1000,

  //in ms
  CLIENT_LOAD_PAGE: 3 * 1000,

  //in ms
  LOOP_FOR_LT_DURATION_DEFAULT: 1000,

  //in ms
  LOOP_WHILE_DURATION_DEFAULT: 1000,

  //in ms
  LOOP_WHILE_ASYNC_DURATION_DEFAULT: 2 * 1000,
};
